import { useMutation } from 'react-query';

import { registerAnonymousRenter } from '../api';

interface IProps {
  registerUser: (email: string, formValues: any) => void;
}

export const useMutationRegisterRenter = ({ registerUser }: IProps) => {
  const { mutate, status, error } = useMutation(registerAnonymousRenter, {
    onSuccess: (_, variables) => {
      registerUser(variables.email, variables);
    },
  });

  return { mutate, status, error };
};
